// extracted by mini-css-extract-plugin
export default {"AllDocumentsLinkContainer":"_AllDocumentsLinkContainer--DY0lY","AllDocumentsLink":"_AllDocumentsLink--tqyfw","Active":"_Active--ixYtl"};